import styled, { css, keyframes } from 'styled-components';
import { InputTag } from 'components/Input/styles';
import Button from 'components/Button';
import Icon from '../../../../components/Icon';
import HoverIcon from '../../../../components/HoverIcon';
import { border1, boxShadow1, whitesmoke } from 'utils/style/colors';

export const DocumentsContainer = styled.div`
  width: auto;
  display: flex;
  flex-direction: column;
`;

export const DocumentsForm = styled('form')`
  flex: none;
  display: flex;
  flex-direction: column;
`;

export const DocumentsFormTitle = styled('div')`
  color: #90a4ae;
  font-size: 16px;
  margin-bottom: 10px;
`;

export const DocumentInputContainer = styled('div')`
  display: flex;
  align-items: stretch;
  flex-direction: column;
  justify-content: space-between;
`;

export const AddDocumentButton = styled(Button)`
  & > span {
    justify-content: center;
  }
`;

export const StyledInput = InputTag.withComponent('input');

const fadeItem = keyframes`
  0% {
    opacity: 0;
    transform: translateY(-30px);
  }
  100% {
    opacity: 1;
    transform: translateY(0);
  }
`;

const animationRule = css`
  ${fadeItem} cubic-bezier(0.075, 0.82, 0.165, 1) 0.5s;
`;

export const DocumentsListContainer = styled('ul')`
  border: 1px solid #34c8b6;
  display: flex;
  overflow: auto;
  overflow: overlay;
  margin-top: 15px;
  box-shadow: ${boxShadow1};
  flex-direction: column;
  & > li {
    flex: none;
    display: block;
    padding: 10px 10px 10px 20px;
    position: relative;
    animation: ${animationRule};
    background: ${whitesmoke};
    min-height: fit-content;
    align-items: center;
    border-bottom: 1px solid #dcdcdc;
  }
`;

export const DocumentDescription = styled('div')`
  color: #90a4ae;
  font-size: 12px;
  font-weight: 400;
`;

export const DocumentName = styled('div')`
  font-weight: 400;
  margin: 10px;
`;

export const Thumb = styled('img')`
  width: 80px;
  height: 80px;
`;

export const DocumentItem = styled('div')`
  display: flex;
  margin: 10px;
  border: ${border1};
  border-radius: 10px;
  padding: 10px;
  background: lightgray;
`;
export const Document = styled('div')`
  flex-grow: 1;
  display: flex;
  align-items: center;
`;

export const DocInputCont = styled('div')`
  display: flex;
  height: 100px;
  flex-direction: row;
  flex-wrap: nowrap;
  align-content: center;
  align-items: center;
  justify-content: space-evenly;
}


`;

export const CustomIcon = styled(Icon)`
  display: block;
  padding-top: 0.5rem;
`;

export const SelectedInfo = styled('div')`
  display: flex;
  flex-direction: column;
  justify-content: space-evenly;
`;
export const SelectedImage = styled('a')`
  display: flex;
  flex-direction: row;
`;
export const ThumbImage = styled('img')`
  border-radius: 10px;
  width: 100px;
  height: 100px;
`;

export const Size = styled('div')`
  color: black;
`;
export const SignatureThumbContainer = styled('div')`
  height: 100%;
  display: block;
  position: relative;
`;

export const Progress = styled('span')`
  margin: 10px;
`;
export const Remove = styled(HoverIcon)`
  position: absolute;
  align-self: normal;
`;
